import Page from 'pages/Page';

import Chat from '@/components/chat';

export default function Home() {
  return (
    <Page>
      <Chat />
    </Page>
  );
}
